import { render, staticRenderFns } from "./SquareTinplateBadge.vue?vue&type=template&id=31cc91e1&scoped=true&"
import script from "./SquareTinplateBadge.vue?vue&type=script&lang=js&"
export * from "./SquareTinplateBadge.vue?vue&type=script&lang=js&"
import style0 from "./SquareTinplateBadge.vue?vue&type=style&index=0&id=31cc91e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc91e1",
  null
  
)

component.options.__file = "SquareTinplateBadge.vue"
export default component.exports